module.exports = __webpack_public_path__ + "../resources/img/ic-re-arrow-down.2f4207ec.svg";